import { StyledReactSelect } from '@fountain/fountain-ui-components';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React, { VFC } from 'react';
import { useIntl } from 'react-intl';

import { Description } from './Description';
import { SettingTitle } from './SettingTitle';

import { VALID_DEFAULT_LOCATION_FILTERS } from '../constants';
import { HandleSettingChange, Message, SettingKey } from '../types';

const useStyles = makeStyles(theme => ({
  setting: {
    margin: theme.spacing(2, 0, 0, 0),
  },
  select: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

export interface DefaultLocationSelectorProps {
  settingKey: SettingKey;
  title: Message;
  description: Message;
  placeholder: Message;
  selectedLocation: string | null;
  onChange: HandleSettingChange;
  className?: string;
  disabled?: boolean;
}

export const DefaultLocationSelector: VFC<DefaultLocationSelectorProps> = ({
  settingKey,
  title,
  description,
  placeholder,
  selectedLocation,
  onChange,
  className,
  disabled,
}) => {
  const styles = useStyles();
  const intl = useIntl();

  const handleLocationChange = (selected: { key: string; label: string }) => {
    onChange(settingKey, selected.key);
  };

  return (
    <div className={classnames(styles.setting, className)}>
      <SettingTitle value={title} />
      <Description value={description} />
      <div className={styles.select}>
        <StyledReactSelect
          options={VALID_DEFAULT_LOCATION_FILTERS}
          value={
            VALID_DEFAULT_LOCATION_FILTERS.find(
              loc => loc.key === selectedLocation,
            ) ??
            VALID_DEFAULT_LOCATION_FILTERS.find(
              loc => loc.key === 'current_location',
            )
          }
          onChange={handleLocationChange}
          placeholder={intl.formatMessage(placeholder)}
          getOptionLabel={(location: { label: string }) => location.label}
          getOptionValue={(location: { key: string }) => location.key}
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};
